import { AuthBaseClient } from '../base-client';
import {
  smsTestReplyResponseSchema,
  smsTestStartResponseSchema,
  type SmsTestReplyBody,
  type SmsTestReplyResponse,
  type SmsTestStartResponse,
  type StartSmsTestBody,
} from './types';

/**
 * Client for the in-product SMS-agent test tool (`/api/sms-test/*`). The API
 * proxies to the real `apps/sms-agent` service; responses are Zod-parsed at the
 * boundary. Session-cookie auth (browser) — no token needed.
 */
export class SmsTestClient extends AuthBaseClient {
  /** Begin a real outbound conversation; returns the opener + conversation id. */
  async start(body: StartSmsTestBody, signal?: AbortSignal): Promise<SmsTestStartResponse> {
    const raw = await this.post<unknown>('/api/sms-test/start', body, signal);
    return smsTestStartResponseSchema.parse(raw);
  }

  /** Feed one patient reply; returns the agent's response + whether it ended. */
  async reply(body: SmsTestReplyBody, signal?: AbortSignal): Promise<SmsTestReplyResponse> {
    const raw = await this.post<unknown>('/api/sms-test/reply', body, signal);
    return smsTestReplyResponseSchema.parse(raw);
  }
}
